import React from 'react';
import { useLanguage } from './LanguageContext';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  const testimonials = [{
    quote: t('testimonials.1.quote'),
    author: t('testimonials.1.author'),
    initials: 'SM',
    color: 'bg-brand-sky text-brand-deep'
  }, {
    quote: t('testimonials.2.quote'),
    author: t('testimonials.2.author'),
    initials: 'LG',
    color: 'bg-brand-teal text-white'
  }, {
    quote: t('testimonials.3.quote'),
    author: t('testimonials.3.author'),
    initials: 'AT',
    color: 'bg-brand-lilac text-white'
  }];
  return <section className="py-14 md:py-24 bg-brand-light relative overflow-hidden" data-id="element-197">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full opacity-50 pointer-events-none" data-id="element-198">
        <div className="absolute top-20 left-10 w-64 h-64 bg-white rounded-full blur-3xl opacity-60" data-id="element-199"></div>
        <div className="absolute bottom-20 right-10 w-80 h-80 bg-brand-sky/20 rounded-full blur-3xl opacity-60" data-id="element-200"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-201">
        <div className="text-center mb-10 md:mb-16" data-id="element-202">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-deep mb-4 font-heading" data-id="element-203">
            {t('testimonials.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-light" data-id="element-204">
            {t('testimonials.subtitle')}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8" data-id="element-205">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-gray-100 flex flex-col h-full" data-id="element-206">
              <div className="flex gap-1 mb-6" data-id="element-207">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" data-id="element-208" />)}
              </div>

              <div className="relative flex-grow" data-id="element-209">
                <Quote className="w-10 h-10 text-brand-light absolute -top-4 -left-2 -z-10" data-id="element-210" />
                <p className="text-gray-600 italic leading-relaxed relative z-10" data-id="element-211">
                  "{item.quote}"
                </p>
              </div>

              <div className="flex items-center gap-4 mt-8 pt-6 border-t border-gray-50" data-id="element-212">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg ${item.color}`} data-id="element-213">
                  {item.initials}
                </div>
                <div data-id="element-214">
                  <p className="font-bold text-brand-deep" data-id="element-215">{item.author}</p>
                  <p className="text-xs text-gray-400 uppercase tracking-wide" data-id="element-216">
                    Patient
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}